export default __webpack_public_path__ + "static/media/art-pro-blk-2.94c5690a.png";